export const layoutPropsByDevice = {
  desktop: {
    buttonsContainer: {
      justifyContent: 'space-between',
      mt: 56,
      width: '100%',
    },
    contentContainer: {
      padding: '80px 40px',
    },
    modalContainer: {},
    subtitle: {
      style: { textAlign: 'center' },
      variant: 'MS-regular-s16-lh25',
    },
    title: {
      mb: 24,
      variant: 'BN-bold-s64-lh55',
    },
  },
  laptop: {
    buttonsContainer: {
      justifyContent: 'space-between',
      mt: 56,
      width: '100%',
    },

    contentContainer: {
      padding: '80px 40px',
    },
    modalContainer: {},
    subtitle: {
      style: { textAlign: 'center' },
      variant: 'MS-regular-s16-lh25',
    },
    title: {
      mb: 24,
      variant: 'BN-bold-s64-lh55',
    },
  },
  mobile: {
    buttonsContainer: {
      flexDirection: 'column',
      gap: 24,
      mt: 'auto',
      width: '100%',
    },
    contentContainer: {
      height: '100%',
      padding: '120px 16px 16px',
    },
    modalContainer: {
      height: '100vh',
      modalMaxHeight: '100vh',
    },
    subtitle: {
      variant: 'MS-regular-s16-lh25',
    },
    title: {
      mb: 40,
      variant: 'BN-bold-s48-lh58',
    },
  },
  tablet: {
    buttonsContainer: {
      flexDirection: 'column',
      gap: 24,
      mt: 'auto',
      width: '100%',
    },
    contentContainer: {
      height: '100%',
      padding: '120px 16px 16px',
    },
    modalContainer: {
      height: '100vh',
      modalMaxHeight: '100vh',
    },
    subtitle: {
      variant: 'MS-regular-s16-lh25',
    },
    title: {
      mb: 40,
      variant: 'BN-bold-s48-lh58',
    },
  },
};
